import {ActionList} from '@primer/react'
import {usePullRequestAnalytics} from '../../hooks/use-pull-request-analytics'

export interface ChangeGroupsPreferencesProps {
  changeGroupsPreferenceAvailable: boolean
  showChangeGroups: boolean
  onShowChangeGroupsChange: (value: boolean) => void
}

// Returns the JSX for change groups preferences to be used in ActionList menus.
export function ChangeGroupsPreferences({
  changeGroupsPreferenceAvailable,
  showChangeGroups,
  onShowChangeGroupsChange,
}: ChangeGroupsPreferencesProps): React.ReactNode {
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()

  if (!changeGroupsPreferenceAvailable) {
    return undefined
  }

  const handleToggle = () => {
    const newValue = !showChangeGroups
    sendPullRequestAnalyticsEvent(
      newValue ? 'change_group_preference.show' : 'change_group_preference.hide',
      'CHANGE_GROUP_PREFERENCE_TOGGLE',
    )
    onShowChangeGroupsChange(newValue)
  }

  return (
    <>
      <ActionList.Divider />
      <ActionList.Group aria-label="Change Groups" selectionVariant="single">
        <ActionList.Item selected={showChangeGroups} onSelect={handleToggle}>
          Show changes by group
          <ActionList.Description variant="block">Organize changes into groups with Copilot</ActionList.Description>
        </ActionList.Item>
      </ActionList.Group>
    </>
  )
}
